if (!customElements.get('sx-nova-serial')) {
  customElements.define('sx-nova-serial', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.form = this.input?.form;
      if (!this.form || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.sync = () => {
        const entered = this.input.value.trim().length > 0;
        this.input.setCustomValidity(entered ? '' : this.input.dataset.errorMessage);
        for (const button of this.form.elements) {
          if (!button.matches('button[type="submit"], input[type="submit"]')) continue;
          if (!entered) {
            if (!button.hasAttribute('data-sx-nova-locked')) button.setAttribute('data-sx-nova-locked', '');
            if (!button.disabled) button.disabled = true;
          } else if (button.hasAttribute('data-sx-nova-locked')) {
            button.removeAttribute('data-sx-nova-locked');
            if (this.dataset.available === 'true') button.disabled = false;
          }
        }
      };
      this.input.addEventListener('input', this.sync, {signal});
      this.input.addEventListener('change', this.sync, {signal});
      this.input.addEventListener('blur', () => {
        this.input.value = this.input.value.trim();
        this.sync();
      }, {signal});
      this.form.addEventListener('submit', event => {
        this.input.value = this.input.value.trim();
        this.sync();
        if (!this.input.validity.valid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.input.focus();
          this.input.reportValidity();
        }
      }, {capture: true, signal});
      this.form.addEventListener('reset', () => queueMicrotask(this.sync), {signal});
      window.addEventListener('pageshow', this.sync, {signal});
      document.addEventListener('DOMContentLoaded', this.sync, {once: true, signal});
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.form, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled']});
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
